import React from 'react'
import { ModalCadastro } from '../../../../../components/Modais'
import { BotaoPadrao } from '../../../../../components/Botoes'
import { InputDatePicker } from '../../../../../components/Inputs'
import { InputEstabelecimentoSaude } from '../../../../../components/InputsAutoComplete'
import { obterGuiasParaImportacao } from '../../../../../util/FuncoesComuns'
import { InputCirurgiaoCombo } from '../../../../../components/InputsAutoCompleteV2'

const ModalFiltrosGuias = ({ propsFormik, guias, setGuias, setCarregando }) => (
    <ModalCadastro
        titulo={'Filtros'}
        show={propsFormik.values.modalAberto}
        setShowModal={(val) => propsFormik.setFieldValue('modalAberto', val)}>
        <div className='row'>
            <InputEstabelecimentoSaude
                placeholder="Estabelecimento de Saúde"
                label="Estabelecimento de Saúde"
                name="filtros.estabelecimento_saude"
                propsFormik={propsFormik}
                classeTooltip={'tooltip-input-modal'}
                onChange={(e) => propsFormik.setFieldValue('filtros.estabelecimento_saude', e)}
            />
            <InputCirurgiaoCombo 
                label="Cirurgião" 
                placeholder="Cirurgião" 
                name="filtros.cirurgiao" 
                propsFormik={propsFormik} 
                classeTooltip={'tooltip-input-modal'} 
                multiplo />

            <InputDatePicker
                label="Data Inicial Procedimento"
                name="filtros.data_inicial_procedimento"
                classeTooltip={'tooltip-input-modal'}
                type="text"
                setarValor={v => propsFormik.setFieldValue("filtros.data_inicial_procedimento", v)}
                onChange={v => propsFormik.setFieldValue("filtros.data_inicial_procedimento", v)}
                placeholder="Data Inicial Procedimento"
            />
            <InputDatePicker
                label="Data Final Procedimento"
                name="filtros.data_final_procedimento"
                type="text"
                classeTooltip={'tooltip-input-modal'}
                setarValor={v => propsFormik.setFieldValue("filtros.data_final_procedimento", v)}
                onChange={v => propsFormik.setFieldValue("filtros.data_final_procedimento", v)}
                placeholder="Data Final Procedimento"
            />
            <InputDatePicker
                label="Data Inicial Registro"
                name="filtros.data_inicial_registro"
                type="text"
                classeTooltip={'tooltip-input-modal'}
                setarValor={v => propsFormik.setFieldValue("filtros.data_inicial_registro", v)}
                onChange={v => propsFormik.setFieldValue("filtros.data_inicial_registro", v)}
                placeholder="Data Inicial Registro"
            />
            <InputDatePicker
                label="Data Final Registro"
                name="filtros.data_final_registro"
                type="text"
                classeTooltip={'tooltip-input-modal'}
                setarValor={v => propsFormik.setFieldValue("filtros.data_final_registro", v)}
                onChange={v => propsFormik.setFieldValue("filtros.data_final_registro", v)}
                placeholder="Data Final Registro"
            />
        </div>
        <div className='direita container-botoes mb-3 group-salvar-novo'>
            <BotaoPadrao
                texto='Filtrar'
                type="button"
                click={() => {
                    if (propsFormik.errors.filtros)
                        setGuias([])

                    propsFormik.setFieldValue('modalAberto', false)
                    if (setCarregando) setCarregando(true)
                    obterGuiasParaImportacao(propsFormik, (val) => {
                        setGuias([...(guias.filter(x => x.especifica)), ...val])
                        if (setCarregando) setCarregando(false)
                    })
                }}
            />
        </div>
    </ModalCadastro>
)

export default ModalFiltrosGuias
